
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbModelo extends AppService {

  abstract getAllModelosBiccateca(): Observable<any>;
  abstract getFisrtModeloLockerPorNome(nome: string): any;
}